export default __webpack_public_path__ + "static/media/web_start_3.0.48300a67.png";